import { STORE_USER } from '../constants/list';

export function storeUserInfo(user) {

  return {
    type: STORE_USER,
    payload: user
  }

}